export enum CONTACT_TYPE {
  PRIVATE = 'private',
  COMPANY = 'company',
}
